import { createContext } from "react";

export const ProgramModalContext = createContext();
